import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { HSASelectorContentRow } from './HotelStandaloneContentRow';
import { DpPaxMessages } from '../DpPaxSelector/DpPaxMessages';
import { KidSelector } from '../DpPaxSelector/KidSelector';
import { RoomsPaxProps, PaxConstants, HotelStandalonePaxRestrictionPropsDefault } from '../../../models';
import { Div } from '../../../layouts';
import { ABUtils } from '../../../utils';

export const HSAPaxContent = ({
    pax,
    paxRestrictions,
    onSelectKidAge,
    onChange,
    roomId,
    showKidError,
    kidsAgeRange,
    isNative,
}) => {
    const { isCssVariation, isCssVariationMobile } = ABUtils.getABs();

    const maxKidAge = kidsAgeRange.slice(-1)[0];

    const HotelStandaloneRows = [
        {
            paxKey: PaxConstants.ADULTS,
            cmsKey: 'adults',
            min: paxRestrictions.minAdults,
            max: paxRestrictions.maxAdults,
            value: pax.adults,
            ageRange: `(+${maxKidAge + 1})`,
        },
        {
            paxKey: PaxConstants.KIDS,
            cmsKey: 'children',
            min: paxRestrictions.minKids,
            max: paxRestrictions.maxKids,
            value: pax.kids,
            ageRange: `(${0}-${maxKidAge})`,
        },
    ];

    const isKids = (row) => row.paxKey === PaxConstants.KIDS;

    const classNames = classnames({
        'odf-box-content odf-box-content-md': !isCssVariation,
        'odf-space-inner-top-m odf-space-inner-bottom-m': isCssVariation,
        'prisma-responsive-space-horizontal': isCssVariationMobile,
    });

    return (
        <>
            <div className="odf-stroke-primary" />
            <Div className={classNames} data-testid="room-selector-item">
                {HotelStandaloneRows.map((row) => {
                    const isKidsResponse = isKids(row);
                    const rowId = `${roomId}${row.paxKey}`;
                    const hideIfNoKid = pax.kids.length > 0;
                    return (
                        <React.Fragment key={rowId}>
                            <HSASelectorContentRow
                                {...row}
                                value={isKidsResponse ? row.value.length : row.value}
                                onChange={onChange}
                                ageCmsKey="roomSelector"
                            />
                            {isKidsResponse && hideIfNoKid && (
                                <KidSelector
                                    kids={row.value}
                                    onSelectKidAge={onSelectKidAge}
                                    showKidError={showKidError}
                                    isNative={isNative}
                                    kidsAgeRange={kidsAgeRange}
                                />
                            )}
                        </React.Fragment>
                    );
                })}
                <DpPaxMessages kids={pax.kids.length} restrictions={HotelStandalonePaxRestrictionPropsDefault} />
            </Div>
            <div className="odf-stroke-primary" />
        </>
    );
};

HSAPaxContent.propTypes = {
    onSelectKidAge: PropTypes.func.isRequired,
    pax: RoomsPaxProps.isRequired,
    paxRestrictions: PropTypes.shape({
        minAdults: PropTypes.number,
        maxAdults: PropTypes.number,
        minKids: PropTypes.number,
        maxKids: PropTypes.number,
    }).isRequired,
    roomId: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    showKidError: PropTypes.bool.isRequired,
    isNative: PropTypes.bool,
    numPax: PropTypes.number.isRequired,
    kidsAgeRange: PropTypes.arrayOf(PropTypes.number),
};

HSAPaxContent.defaultProps = {
    isNative: false,
};
